import { useEffect, useState } from "react";

/**
 * Emits the marker the printer waits for before capturing a page.
 *
 * Mount it as the last child of the branch that renders once data has loaded —
 * `waitForSelector` fires the instant this appears, so signalling early is the
 * same as not signalling at all.
 *
 * This replaced fixed `setTimeout` waits in the printer. It matters most for
 * the running header, which the printer scrapes out of the rendered page: the
 * logo inside it is fetched and inlined by a `useEffect`, so against a timer
 * its presence was a race — and the asset summary and overview reports had no
 * timer at all, relying on the network going idle.
 */
const PrintReady = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    Promise.all([
      document.fonts.ready,
      // A broken image must not hold the whole report hostage.
      ...Array.from(document.images).map((img) => img.decode().catch(() => {})),
    ]).then(() => {
      // Two frames: the first runs before paint, the second after it.
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          if (!cancelled) setReady(true);
        }),
      );
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return ready ? <div data-print-ready hidden /> : null;
};

export default PrintReady;
